<!-- src/pages/train/trainCon/exportStatusModal.vue -->
<template>
  <el-dialog
    title="系统提示"
    :visible="visible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="420px"
    custom-class="export-confirm-dialog"
  >
    <div class="confirm-content">
      <i class="el-icon-warning warning-icon"></i>
      <div class="confirm-body">
        <div class="confirm-message">正在导出中，请耐心等待！<br/>导出成功后会以"短信"方式告知，可点击【导出结果】进行下载。</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ExportStatusModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm-content {
  display: flex;
  align-items: flex-start;
  
  .warning-icon {
    font-size: 24px;
    color: #E6A23C;
    margin-right: 12px;
    margin-top: 2px;
  }
  
  .confirm-body {
    flex: 1;
    
    .confirm-message {
      font-size: 14px;
      color: #606266;
      line-height: 24px;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  
  ::v-deep .el-button {
    padding: 9px 15px;
  }
}
</style>

<style lang="scss">
.export-confirm-dialog {
  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #DCDFE6;
  }
  
  .el-dialog__body {
    padding: 30px 20px;
  }
  
  .el-dialog__footer {
    padding: 15px 20px;
    border-top: 1px solid #DCDFE6;
  }
}
</style>